<template>
    <CModal class="modal-chooseFile addSchedule"
            title="Danh sách tập tin âm thanh từ kho biên tập"
            :show.sync="isShowModal" :closeOnBackdrop="false"
            :size="'xl'">
      <div id="fileManagementAddMany">
        <CRow class="mb-3 search-panel">
          <CCol xs="12" sm="6" md="3" lg="2" xl="2">
            <div class="form-group">
              <label for="datepicker">Từ ngày - đến ngày</label>
              <DatePicker id="datepicker" v-model="dateRange"
                          :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                          locale="vi"
                          is-range class="datepicker"
                          :popover="{ visibility: 'click' }">
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :value="inputValue.start + ' - ' + inputValue.end"
                    v-on="inputEvents.start"
                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                    readonly
                  />
                </template>
              </DatePicker>
            </div>
          </CCol>
          <CCol xs="12" sm="6" md="3" lg="2" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                        ref="districtCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="3" lg="2" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="3" lg="2" xl="2">
            <BaseSelect :options="typeFileSelect.options" :data="typeFileSelect.data"
                        ref="typeFileSelect"></BaseSelect>
          </CCol>
          <!--          <CCol xs="12" sm="6" md="4" lg="4" xl="2">-->
          <!--            <BaseInput-->
          <!--              :options="titleInput.options"-->
          <!--              :data="titleInput.data"-->
          <!--              :listener="titleInput.listener"-->
          <!--            />-->
          <!--          </CCol>-->
          <CCol xs="12" sm="6" md="3" lg="2" xl="2" class="search-action-col ml-auto">
            <div class="form-group mb-0">
              <label class="search-action-label"></label>
              <div class="search-action-wrap">
                <CButton
                  color="primary"
                  v-c-tooltip.hover="'Tải lại'"
                  class="btn-action-primary search-action-btn"
                  @click="reloadData()">
                  <i class="fa fa-refresh"></i>&nbsp; Tải lại
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>
        <CCard class="content-fade-in mt-3p5">
          <CCardBody>
            <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
              @row-click="rowClickTable($event)" ref="mainTable">
              <template #index="{ index, item }">
                <!-- <td class="action-btn-group">
                  <checkbox
                    type="radio"
                    addInputClasses="override-custom"
                    custom
                    :value="item.id"
                    name="fileAddScheduleSelected"
                    :checked="item.isSelected"
                  />
                </td> -->

                <td class="group-checkbox">
                    <div class="custom-control custom-checkbox">
                        <input
                        type="checkbox"
                        class="custom-control-input"
                        v-model="itemChooseFileSelectedId"
                        :value="item.id"
                        :id="item.id"
                        v-c-tooltip.hover="'Selected'"
                        />
                        <label class="custom-control-label" :for="item.id"></label>
                    </div>
                </td>
              </template>
              <template #createDate="{ item }">
                <td v-if="item.createDate != null">
                  {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
                </td>
                <td v-else></td>
              </template>
              <template #duration="{ item }">
                <td>
                  {{ item.duration }}
                  <span v-if="item.size">
                {{ '/ ' + $helper.formatFileSize(item.size) }}
              </span>
                </td>
              </template>
              <template #description="{ item }">
                <td>
                  <span v-if="item.description" :key="item.description" class="description"
                        v-c-tooltip.hover="item.description">
                    {{ item.description }}
                  </span>
                </td>
              </template>
              <template #type="{ item }">
                <td>
                  <span class="badge badge-light" v-if="item.type == 0">Biên tập</span>
                  <span class="badge badge-light" v-else-if="item.type == 1">Chuyển đổi văn bản</span>
                  <span class="badge badge-light" v-else-if="item.type == 2">Ghi âm tệp tin</span>
                  <span class="badge badge-light" v-else-if="item.type == 3">Ghép tệp tin</span>
                </td>
              </template>
              <template #title="{ item }">
                <td>{{ item.title }}</td>
              </template>
              <template #action="{ item }">
                <td class="action-btn-group">
                  <CInputRadio
                    type="radio"
                    addInputClasses="override-custom"
                    custom
                    :value="item.id"
                    name="test"
                    :checked="item.checked"
                  />
                </td>
              </template>
            </BaseTable>
          </CCardBody>
        </CCard>

        <BaseModal :title="'Xem tệp tin: ' + previewModel.title" :show.sync="previewModel.isShowModal"
                   :closeOnBackdrop="false">
          <template v-slot:body-wrapper>
            <div class="modal-body content-fade-in">
              <audio :src="previewModel.url" controls autoplay style="width: 100%" ref="previewAudio"></audio>
            </div>
          </template>
          <template v-slot:footer>
            <div slot="footer">
              <button type="button" class="btn btn-secondary" @click="closePreviewAudio()"><i
                class="fa fa-close"></i> Đóng
              </button>&nbsp;
            </div>
          </template>
        </BaseModal>

      </div>
      <template v-slot:footer>
        <button type="button" class="btn btn-primary" :disabled="itemChooseFileSelected.length == 0 || itemChooseFileSelected == null"
                @click="submitSelectedChooseFile()">
          <i class="fa fa-check"></i> Chọn
        </button>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
      </template>
    </CModal>
  </template>

  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseModal from "@/views/base/BaseModal";
  import {DatePicker} from "v-calendar";
  import VideoPlayer from "@/views/base/VideoPlayer";

  export default {
    name: "fileManagementAddMany",
    components: {
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      DatePicker,
      BaseModal,
      VideoPlayer,
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
      showErrorMsg: {
        type: "error",
        title: "Error",
      },
      showWarningMsg: {
        type: "warn",
        title: "warn",
      },
    },
    data() {
      let that = this;
      return {
        isShowModal: true,
        loading: {
          value: false,
        },
        previewModel: {
          isShowModal: false,
          title: '',
          url: ''
        },
        actionData: {
          model: {
            selectedAll: false,
            fileId: null,
            fileName: null
          }
        },
        dateRange: {
          start: that.$helper.subtractNowDate(30),
          end: new Date()
        },
        districtCodeInput: {
          options: {
            filter: true,
            label: "Quận/Huyện",
            selectAllText: "Tất cả Quận/Huyện",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
          },
          data: {
            name: "districtCode",
            items: [],
            model: null,
            source: {
              url: '/common/findByParentCodeAndCode',
              dataSubmit: function () {
                return {
                  level: 1
                }
              },
              response: function (dataResponse) {
                that.districtCodeInput.data.items = dataResponse.data;
              }
            },
          }
        },
        wardCodeInput: {
          options: {
            filter: true,
            label: "Phường/Xã",
            selectAllText: "Tất cả Phường/Xã",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
            // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
          },
          data: {
            name: "wardCode",
            model: null,
            items: [],
            source: {
              url: '/common/findByParentCodeAndCode',
              dataSubmit: function () {
                return {
                  parentCode: that.districtCodeInput.data.model,
                  level: 2
                }
              },
              response: function (dataResponse) {
                that.wardCodeInput.data.items = dataResponse.data;
              }
            },
          }
        },
        typeFileSelect: {
          options: {
            filter: true,
            label: "Loại tệp tin",
            selectAllText: "Tất cả loại tệp tin",
            'keyField': 'key',
            'valueField': 'value',
          },
          data: {
            name: "type",
            model: '',
            items: [
              {key: '0', value: 'Biên tập'},
              {key: '1', value: 'Chuyển đổi văn bản'},
              {key: '2', value: 'Ghi âm tệp tin'},
              {key: '3', value: 'Ghép tệp tin'},
            ],

          }
        },
        locationCode: {
          data: {
            name: 'locationCode',
            model: ''
          }
        },
        titleInput: {
          options: {
            placeholder: "Tiêu đề bản tin",
            label: "Tiêu đề bản tin",
          },
          data: {
            name: "name",
            model: "",
          },
        },
        mainTable: {
          options: {
            fields: [
              {key: "index", label: "#", sorter: false, filter: false},
              {key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%"},
              {key: "title", label: "Tiêu đề"},
              {key: "duration", label: "Thời lượng / Kích thước"},
              {key: "description", label: "Mô tả", sorter: false, filter: false},
              {key: "locationName", label: "Địa bàn"},
              {key: "fileTypeName", label: "Lĩnh vực"},
              // {key: "url", label: "Nội dung bản tin", sorter: false, filter: false},
              {key: "type", label: "Loại tệp tin", sorter: true, filter: false},
              // {key: "action", label: "Thao tác", sorter: false, filter: false},
            ],
            slots: [
              "index", "createDate", "action", "duration", "url", "type", "description"
            ],
            sorter: true,
            columnFilter: false,
            clickableRows: true,
            hover: true,
            itemsPerPageSelect: { label: ' ', values: [10, 15, 20, 50], external: true },
            pageSize: 10,
            tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false }
          },
          dataSource: {
            url: "/file-management/getPages",
            dataSubmit: () => {
              const params = {
                districtCode: this.normalizeFilterValue(this.districtCodeInput.data.model),
                wardCode: this.normalizeFilterValue(this.wardCodeInput.data.model),
                type: this.normalizeFilterValue(this.typeFileSelect.data.model),
                locationCode: this.normalizeFilterValue(this.locationCode.data.model),
                name: this.titleInput && this.titleInput.data ? this.titleInput.data.model : "",
              };
              params.fromDate = this.$helper.formatDateDDMMYYYY(this.dateRange.start);
              params.toDate = this.$helper.formatDateDDMMYYYY(this.dateRange.end);
              params.status = 2;
              return params;
            },
            response: (dataResponse) => dataResponse.data
          }
        },
        itemChooseFileSelected: [],
        itemChooseFileSelectedId: []
      };
    },
    methods: {
      normalizeFilterValue(value) {
        return (value === null || value === undefined || value === '') ? null : String(value);
      },
      loadDataFile() {
        if (this.$refs.mainTable) {
          this.$refs.mainTable.loadData(false);
        }
      },
      reloadData() {
        this.loadDataFile();
      },
    //   rowClickTable(...args) {
    //     this.mainTable.items.map((item, index) => {
    //       if (index === args[1]) {
    //         // item.isSelected = true;
    //         this.itemChooseFileSelected.push(item);
    //         this.itemChooseFileSelectedId.push(item.id);
    //       } else {
    //         // item.isSelected = false;
    //         this.itemChooseFileSelected.remove(item);
    //         this.itemChooseFileSelectedId.remove(item.id);
    //       }
    //     });
    //   },
    rowClickTable(payload) {
      const _item = payload && payload.item ? payload.item : payload;
      const _column = payload && payload.column ? payload.column : null;
      const _event = payload && payload.event ? payload.event : null;
      if (!_event) return;
      let targetClick = _event.target;
      if (_column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (_item && _item.id) {
        if (this.itemChooseFileSelectedId.includes(_item.id)) {
          const index = this.itemChooseFileSelectedId.indexOf(_item.id)
          if (index > -1) {
            this.itemChooseFileSelectedId.splice(index, 1);
            this.itemChooseFileSelected.splice(index, 1);
            _item._classes = 'inactive';
          }
        } else {
          _item._classes = 'active';
          this.itemChooseFileSelectedId.push(_item.id);
          this.itemChooseFileSelected.push(_item);
        }
      }
    },
      submitSelectedChooseFile() {
        if (this.itemChooseFileSelected == null || this.itemChooseFileSelected.length == 0) {
          return;
        }
        this.$emit('file:selected', this.itemChooseFileSelected);
      },
      viewFile(title, url) {
        this.previewModel.url = url;
        this.previewModel.isShowModal = true;
        this.previewModel.title = title;
      },
      closePreviewAudio() {
        this.$refs.previewAudio.pause();
        this.previewModel.isShowModal = false;
      },
    },
    created: function () {
    },
    mounted() {
      this.loadDataFile();
    },
    watch: {
      isShowModal: function (value) {
        if (!value) {
          this.$emit("close-modal", false);
        }
      },
      dateRange: function (newValue) {
        if (newValue) {
          this.loadDataFile();
        } else {
          this.dateRange = {
            start: this.$helper.subtractNowDate(30),
            end: new Date()
          }
        }
      },
      'districtCodeInput.data.model': function (value) {
        if (value) {
          // this.$refs.wardCodeInput.loadData();
          this.locationCode.data.model = value;
          // this.wardCodeInput.options.disabled = false;
        } else {
          // this.wardCodeInput.data.items = [];
          // this.wardCodeInput.options.disabled = true;
        }
        this.$refs.wardCodeInput.loadData();
        this.wardCodeInput.data.model = null
      },
      'wardCodeInput.data.model': function (value) {
        if (value) {
          this.locationCode.data.model = value;
        } else {
          this.locationCode.data.model = this.districtCodeInput.data.model;
        }
        this.loadDataFile();
      },
      'typeFileSelect.data.model': function () {
        this.loadDataFile();
      }
    },
    computed: {
    },
  };
  </script>

  <style>
  .row-2 .form-group {
    margin-top: 0 !important;
  }

  #fileManagementAddMany .c-datatable-filter .form-control {
    min-width: 320px;
    width: 420px;
    max-width: 100%;
  }

  .addSchedule .modal-xl {
    max-width: 72vw;
  }

  @media (max-width: 991.98px) {
    .addSchedule .modal-xl {
      max-width: 96vw;
    }
  }

  @media (max-width: 576px) {
    .addSchedule .modal-dialog {
      margin: 0.35rem auto;
    }

    .addSchedule .modal-content {
      min-height: 96vh;
    }

    #fileManagementAddMany {
      max-height: none;
      overflow: visible;
    }
  }

  #fileManagementAddMany .search-panel {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  #fileManagementAddMany .search-panel .form-group,
  #fileManagementAddMany .search-panel .group-select,
  #fileManagementAddMany .search-panel .select2-container,
  #fileManagementAddMany .search-panel .select2-selection--single,
  #fileManagementAddMany .search-panel .form-control,
  #fileManagementAddMany .search-panel .datepicker input {
    width: 100% !important;
  }

  #fileManagementAddMany .search-panel .search-action-col {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding-right: 0 !important;
  }

  #fileManagementAddMany .search-panel .search-action-label {
    display: block;
    height: 24px;
    margin-bottom: 0.5rem;
  }

  #fileManagementAddMany .search-panel .search-action-wrap {
    display: flex;
    justify-content: flex-end;
  }

  #fileManagementAddMany .search-panel .search-action-btn {
    margin-left: 0 !important;
  }
  </style>

